import { useEffect } from 'react';

/**
 * Locks the document's scroll while an overlay layer is open (ADR 0048 §5).
 *
 * On handheld the document is the page's one scroller, so a drawer or sheet
 * over it must stop it: otherwise a flick that reaches the end of the layer's
 * own scroller carries on into the page underneath. The lock is an attribute on
 * `<html>` (`html[data-scroll-lock] { overflow: hidden }` in base.css) rather
 * than an inline style, so CSS owns what "locked" means.
 *
 * Counted, not boolean: the drawer can hand over to the account sheet, and two
 * layers can be mounted for a frame. The first release must not unlock the page
 * while the second is still open.
 */
let holders = 0;

export const SCROLL_LOCK_ATTRIBUTE = 'data-scroll-lock';

export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    holders += 1;
    document.documentElement.setAttribute(SCROLL_LOCK_ATTRIBUTE, '');
    return () => {
      holders = Math.max(0, holders - 1);
      if (holders === 0) document.documentElement.removeAttribute(SCROLL_LOCK_ATTRIBUTE);
    };
  }, [active]);
}
